<div class="error-page">
  <div class="error-header">500</div>
  <p class="error-message fk-h1">{{ 'fkErrors.pageNotFound' | translate }}</p>
  <p class="error-description fk-subtitle1">{{ 'fkErrors.pageNotFound500Msg' | translate }}</p>
<!--  <p class="error-contact fk-subtitle1">-->
<!--    {{ 'fkErrors.contactMsg1part' | translate }}-->
<!--    <a href="tel:+380674567890">+38 (067) 456-7890</a><br>-->
<!--    {{ 'fkErrors.contactMsg2part' | translate }}-->
<!--    <a href="mailto:support@frogo.com">support&#64;frogo.com</a>-->
<!--  </p>-->
  <img [src]="logoPath" class="frog-illustration" />
</div>
